import { Entity } from "@/app/common/base/entity"
import { Expose } from "class-transformer"

export class WoongarantInsuranceDocument extends Entity<WoongarantInsuranceDocument> {

    @Expose({ name: 'api_id' })
    apiId!: string

    @Expose()
    description!: string
}
